import { Typography } from "@mui/material";
import { Box, styled } from "@mui/system";
import IconaVolume from 'assets/images/icona_volume.png'

const CenteredText = styled(Box)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const AlzaVolume = () => {
    return (
        <CenteredText>
            <div style={{
                display: 'flex',
                paddingInline: '2rem'
            }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={IconaVolume} alt="incrementa il volume" />
                </div>
                <div>
                    <Typography variant="h6" sx={{ paddingInline: '.5rem', lineHeight: '2rem' }}>
                        Alza il volume per vivere al meglio l’esperienza!
                    </Typography>
                </div>
            </div>
        </CenteredText>
    )
}

export default AlzaVolume;